export const SET_LEFT_NAVBAR_OPEN = 'SET_LEFT_NAVBAR_OPEN';
